import { PublicClientApplication } from '@azure/msal-browser';

const MSALInstance = {
    userId: null,
    msalConfig: new PublicClientApplication({
        auth: {
            clientId: import.meta.env.VITE_APP_CLIENT_ID,
            authority: import.meta.env.VITE_APP_AUTHORITY,
            redirectUri: window.location.origin,
            // navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'localStorage',
        },
    }),
    loginRequest: {
        scopes: [`api://${import.meta.env.VITE_APP_TULIP_CLIENT_ID}/tulip.read.all`],
        // scopes: [`${import.meta.env.VITE_APP_CLIENT_ID}/.default`, 'profile', 'offline_access', 'api://3901b652-acbc-4cf9-a7fe-7d53c1a954a6/tulip.read.all'],
    },
    login: function () {
        this.msalConfig.loginRedirect(this.loginRequest);
    },
    logout: function () {
        this.msalConfig.logoutRedirect({
            account: this.msalConfig.getAccountByUsername(this.userId),
            postLogoutRedirectUri: window.location.origin,
        });
    },
    checkAuth: function () {
        return new Promise((resolve, reject) => {
            this.msalConfig
                .handleRedirectPromise()
                .then((res) => {
                    if (res !== null) {
                        this.userId = res.account.homeAccountId;
                        resolve();
                    } else {
                        const currentAccounts = this.msalConfig.getAllAccounts();
                        if (currentAccounts.length > 0) {
                            this.userId = currentAccounts[0].homeAccountId;
                            resolve();
                        } else {
                            reject();
                        }
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

export default MSALInstance;
